import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { firstValueFrom, Subscription } from 'rxjs';
import { billingOrganisation, complexAddress, complexContact, SsoIdentity } from '../../models';
import { AuthService } from '../../../../services/auth.service';
import { SubscriptionService } from '../../services/subscription.service';

@Component({
  selector: 'app-org-contact-editor',
  templateUrl: './org-contact-editor.component.html',
  styleUrls: ['./org-contact-editor.component.scss']
})
export class OrgContactEditorComponent implements OnInit {
    @Input() org: billingOrganisation;
    @Input() ssoId: SsoIdentity;
    @Output() loaded: EventEmitter<FormGroup> = new EventEmitter<FormGroup>();
    @Output() countryUpdated: EventEmitter<CountryData> = new EventEmitter<CountryData>();

    countries: any[] = [];
    form: FormGroup;

    constructor(private fb: FormBuilder,
        private sub: SubscriptionService) { }

    async ngOnInit() {
        this.countries = await this.sub.getCurrentCountryList();
        this.buildOrgForm();

        this.loaded.emit(this.form);
    }

    get formAdminAddress(){
        const grp = this.form.controls['adminAddress'] as FormGroup;
        return grp;
    }

    get formAdminContact(){
        const grp = this.form.controls['adminContact'] as FormGroup;
        return grp;
    }

    get formBillingAddress(){
        const grp = this.form.controls['billingAddress'] as FormGroup;
        return grp;
    }

    get formBillingContact(){
        const grp = this.form.controls['billingContact'] as FormGroup;
        return grp;
    }



    get adminContact(): complexContact{
        const grp = this.form.controls['adminContact'] as FormGroup;
        const contact = Object.assign({}, grp.getRawValue()) as complexContact;

        return contact;
    }

    get adminAddress(): complexAddress{
        const grp = this.form.controls['adminAddress'] as FormGroup;
        const add = Object.assign({}, grp.getRawValue()) as complexAddress;

        return add;
    }

    get billingContact(): complexContact{
        const grp = this.form.controls['billingContact'] as FormGroup;
        const contact = Object.assign({}, grp.getRawValue()) as complexContact;

        return contact;
    }

    get billingAddress(): complexAddress{
        const grp = this.form.controls['billingAddress'] as FormGroup;
        const add = Object.assign({}, grp.getRawValue()) as complexAddress;

        return add;
    }

    clearValidators(){

    }

    private buildOrgForm() {
        let billingSameAsAdmin = true;
        let emailA = '';
        let phoneA = '';
        let faxA = '';
        let firstNameA = '';
        let lastNameA = '';
        let companyA = '';
        let address1A = '';
        let address2A = '';
        let townA = '';
        let countyA = '';
        let countryA = '';
        let postCodeA = '';

        let emailB = '';
        let phoneB = '';
        let faxB = '';
        let firstNameB = '';
        let lastNameB = '';
        let companyB = '';
        let address1B = '';
        let address2B = '';
        let townB = '';
        let countyB = '';
        let countryB = '';
        let postCodeB = '';

        

        if(this.org){
            //We are editing the data provided
            const aa = this.org.administrativeAddress;
            const ac = this.org.administrativeContact;


            const ba = this.org.billingAddress;
            const bc = this.org.billingContact;

            emailA = ac.email;
            phoneA = ac.phone;
            faxA = ac.fax;
            companyA = ac.company;
            firstNameA = ac.firstName;
            lastNameA = ac.lastName;

            address1A = aa.address1;
            address2A = aa.address2;
            townA = aa.town;
            countyA = aa.country;
            countryA = aa.country;
            postCodeA = aa.postCode;

            emailB = bc.email;
            phoneB = bc.phone;
            faxB = bc.fax;
            companyB = bc.company;
            lastNameB = bc.lastName;
            firstNameB = bc.firstName;

            address1B = ba.address1;
            address2B = ba.address2;
            townB = ba.town;
            countyB = ba.county;
            countryB = ba.country;
            postCodeB = ba.postCode;

            billingSameAsAdmin = complexContact.compare(ac, bc) && complexAddress.compare(aa, ba);
        }else if(this.ssoId){
            //It is a new account based on an SSO login
            //We may have some of this data in the sso response
            emailA = emailB = this.ssoId.email;
            phoneA = phoneB = this.ssoId.phone;
            firstNameA = firstNameB = this.ssoId.givenName;
            lastNameA = lastNameB = this.ssoId.familyName;

            if (this.ssoId.address) {
                const add = JSON.parse(this.ssoId.address);
                address1A = address1B = add.streetAddress;
                townA = townB = add.locality;
                countyA = countyB = add.region;
                countryA = countryB = add.country;
                postCodeA = postCodeB = add.postalCode;
            }
        }
    
        this.form = this.fb.group({
          billingSameAsAdmin: billingSameAsAdmin,
          billingAddress: this.fb.group({
            address1: address1B,
            address2: address2B,
            town: townB,
            county: countyB,
            country: countryB,
            postCode: postCodeB
          }),
          billingContact: this.fb.group({
            company: companyB,
            firstName: firstNameB,
            lastName: lastNameB,
            email: emailB,
            phone: phoneB,
            fax: faxB
          }),
          adminAddress: this.fb.group({
            address1: [address1A, [Validators.required, Validators.minLength(2)]],
            address2: address2A,
            town: townA,
            county: countyA,
            country: [countryA, [Validators.required, Validators.minLength(2)]],
            postCode: [postCodeA, [Validators.required, Validators.minLength(2)]]
          }),
          adminContact: this.fb.group({
            company: companyA,
            firstName: [firstNameA, [Validators.required, Validators.minLength(2)]],
            lastName: [lastNameA, [Validators.required, Validators.minLength(2)]],
            email: [emailA, [Validators.required, Validators.email]],
            phone: phoneA,
            fax: faxA
          })
        });
    
        this.addFormValueWatchers();
        this.addHandlerFormValueWatcher(billingSameAsAdmin);
        this.form.statusChanges.subscribe(r => {
            console.log("form.statusChanges: " + r);
        })
      }

     private adminAddress1Sub: Subscription;
     private  adminAddress2Sub: Subscription;
     private  adminTownSub: Subscription;
     private  adminCountySub: Subscription;
     private  adminPostcodeSub: Subscription;
     private  adminCountrySub: Subscription;
     private  adminFirstNameSub: Subscription;
     private  adminLastNameSub: Subscription;
     private  adminEmailSub: Subscription;
     private  adminPhoneSub: Subscription;
     private  adminFaxSub: Subscription;
     private  adminCompanySub: Subscription;
     private  billingCountrySub: Subscription;
    
     private  addFormValueWatchers() {
        this.form.get('billingSameAsAdmin').valueChanges.subscribe(n => {
          this.addHandlerFormValueWatcher(n);
        })
      }
    
    private  addHandlerFormValueWatcher(n: boolean) {
        let adminAdd = this.form.get('adminAddress');// this.orgFormGroup.get('administrativeAddress');
        let billingAdd = this.form.get('billingAddress'); // this.orgFormGroup.get('billingAddress');
        let adminContact = this.form.get('adminContact');   // this.orgFormGroup.get('administrativeContact');
        let billingContact = this.form.get('billingContact'); // this.orgFormGroup.get('billingContact');
    
        if (n) {
          //We want to add handlers so that changes to admin update billing
          billingAdd.disable();
          billingContact.disable();
          if (this.billingCountrySub) {
            this.billingCountrySub.unsubscribe();
          }
    
          billingAdd.get('address1').setValue(adminAdd.get('address1').value);
          billingAdd.get('address1').clearValidators()
          billingAdd.get('address2').setValue(adminAdd.get('address2').value);
          billingAdd.get('town').setValue(adminAdd.get('town').value);
          billingAdd.get('county').setValue(adminAdd.get('county').value);
          billingAdd.get('country').setValue(adminAdd.get('country').value);
          billingAdd.get('country').clearValidators();
          billingAdd.get('postCode').setValue(adminAdd.get('postCode').value);
          billingAdd.get('postCode').clearValidators()
    
          billingContact.get('firstName').setValue(adminContact.get('firstName').value);
          billingContact.get('firstName').clearValidators();
          billingContact.get('lastName').setValue(adminContact.get('lastName').value);
          billingContact.get('lastName').clearValidators()
          billingContact.get('email').setValue(adminContact.get('email').value);
          billingContact.get('email').clearValidators();
          billingContact.get('phone').setValue(adminContact.get('phone').value);
          billingContact.get('fax').setValue(adminContact.get('fax').value);
          billingContact.get('company').setValue(adminContact.get('company').value);
    
          this.adminAddress1Sub = adminAdd.get('address1').valueChanges.subscribe(a1 => { billingAdd.get('address1').setValue(a1); });
          this.adminAddress2Sub = adminAdd.get('address2').valueChanges.subscribe(a1 => { billingAdd.get('address2').setValue(a1); });
          this.adminTownSub = adminAdd.get('town').valueChanges.subscribe(a1 => { billingAdd.get('town').setValue(a1); });
          this.adminCountySub = adminAdd.get('county').valueChanges.subscribe(a1 => { billingAdd.get('county').setValue(a1); });
          this.adminCountrySub = adminAdd.get('country').valueChanges.subscribe(a1 => {
    
            //update region and currency
            console.log("Admin country value changing: " + a1);
            const country = this.countries.find(x => x.name === a1);
            if (country) {
              billingAdd.get('country').setValue(country.name, { emitEvent: false });
              this.countryUpdated.emit(country);
            } else {
              billingAdd.get('country').setValue('', { emitEvent: false });
            }
          });
          this.adminPostcodeSub = adminAdd.get('postCode').valueChanges.subscribe(a1 => { billingAdd.get('postCode').setValue(a1); });
    
          this.adminFirstNameSub = adminContact.get('firstName').valueChanges.subscribe(a1 => { billingContact.get('firstName').setValue(a1); });
          this.adminLastNameSub = adminContact.get('lastName').valueChanges.subscribe(a1 => { billingContact.get('lastName').setValue(a1); });
          this.adminEmailSub = adminContact.get('email').valueChanges.subscribe(a1 => { billingContact.get('email').setValue(a1); });
          this.adminPhoneSub = adminContact.get('phone').valueChanges.subscribe(a1 => { billingContact.get('phone').setValue(a1); });
          this.adminFaxSub = adminContact.get('fax').valueChanges.subscribe(a1 => { billingContact.get('fax').setValue(a1); });
          this.adminCompanySub = adminContact.get('company').valueChanges.subscribe(a1 => billingContact.get('company').setValue(a1));
        } else {
          //We want to remove handlers and clear values
          this.adminAddress1Sub.unsubscribe();
          this.adminAddress2Sub.unsubscribe();
          this.adminTownSub.unsubscribe();
          this.adminCountySub.unsubscribe();
          this.adminCountrySub.unsubscribe();
          this.adminPostcodeSub.unsubscribe();
          this.adminFirstNameSub.unsubscribe();
          this.adminLastNameSub.unsubscribe();
          this.adminEmailSub.unsubscribe();
          this.adminPhoneSub.unsubscribe();
          this.adminFaxSub.unsubscribe();
          this.adminCompanySub.unsubscribe();
    
          billingAdd.get('address1').setValue('');
          billingAdd.get('address1').setValidators([Validators.required, Validators.minLength(2)]);
          billingAdd.get('address2').setValue('');
          billingAdd.get('town').setValue('');
          billingAdd.get('county').setValue('');
          billingAdd.get('country').setValue('');
          billingAdd.get('country').setValidators([Validators.required, Validators.minLength(2)]);
          this.billingCountrySub = billingAdd.get('country').valueChanges.subscribe(a1 => {
            const country = this.countries.find(x => x.name === a1);
            if (country) {
                this.countryUpdated.emit(country);
            } 
          });
          billingAdd.get('postCode').setValue('');
          billingAdd.get('postCode').setValidators([Validators.required, Validators.minLength(2)]);
    
          billingContact.get('firstName').setValue('');
          billingContact.get('firstName').setValidators([Validators.required, Validators.minLength(2)]);
          billingContact.get('lastName').setValue('');
          billingContact.get('lastName').setValidators([Validators.required, Validators.minLength(2)]);
          billingContact.get('email').setValue('');
          billingContact.get('email').setValidators([Validators.required, Validators.email]);
          billingContact.get('phone').setValue('');
          billingContact.get('fax').setValue('');
          billingContact.get('company').setValue('');
    
          billingContact.enable();
          billingAdd.enable();
        }
    }
    
    handleCountryBlur(addForm) {
        console.log("Handle country blur in signup: " + addForm);
        setTimeout(() => {
          const currentVal = addForm.get('country').value;
          const country = this.countries.find(x => x.name === currentVal);
          if (!country) {
            addForm.get('country').setValue('');
          }
        }, 500);
        
    }
}

interface CountryData{
    region: string;
    currency: string;
}